import {
  type CarQuote,
  ProductType,
  type Quote,
  type VanQuote,
} from "@/api_client";

const requiresMoreInformationForVan = (quote: Quote | undefined): boolean => {
  const vanQuote = quote as VanQuote | undefined;
  return !vanQuote?.vanDetails?.brand;
};
const requiresMoreInformationForCar = (quote: Quote | undefined): boolean => {
  const carQuote = quote as CarQuote | undefined;
  return !carQuote?.carDetails?.brand;
};

export const requiresMoreInformationToProceed = (
  productType: ProductType | undefined,
  quote: Quote | undefined,
): boolean => {
  if (productType === ProductType.VAN) {
    return requiresMoreInformationForVan(quote);
  }
  if (productType === ProductType.CAR) {
    return requiresMoreInformationForCar(quote);
  }
  return false;
};
